export const OPTION_KEYS = {
  users: {
    name: 'userName',
    id: 'userId',
    email: 'emailId',
    description: 'role.roleName',
    photoUrl: 'photoUrl',
    companyLogo: 'company.companyLogoUrl',
  },
  teams: {
    name: 'teamName',
    id: 'teamId',
    description: 'teamDescription',
    photoUrl: '',
  },
};

export const ID_TYPE_SEPARATOR = '-';

export const DEFAULT_OPTION_MODEL = {
  name: '',
  email: '',
  description: '',
  photoUrl: '',
  companyLogo: '',
  id: Number(0),
};
